import UserModel from '$gbusiness/models/user';
import StoreModel from './store';

export default interface CurrentStateModel {
  hidePrice: boolean;
  isLoggedIn: boolean;
  ebrochure: boolean;
  isWholesale?: boolean;
  settings?: any;
  isFactory?: boolean;
  isSalesman?: boolean;
  user?: UserModel;
  store?: StoreModel;
}

export const initialCurrentState: CurrentStateModel = {
  hidePrice: true,
  isLoggedIn: false,
  isWholesale: false,
  ebrochure: true,
};
